export default {
    isFetching: false,
    isRequesting: false,
    cart: {
        products: []
    }
};
